import {createSlice} from '@reduxjs/toolkit';
import type {PayloadAction} from '@reduxjs/toolkit';

export interface FileSystemState {
  isDeleting: boolean;
  deleteItemId?: string;
  downloadingProgress: {[key: string]: number | undefined};
  sharing: {[key: string]: true | undefined};
}

const initialState: FileSystemState = {
  isDeleting: false,
  downloadingProgress: {},
  sharing: {},
};

export const FileSystemSlice = createSlice({
  name: 'fs',
  initialState,
  reducers: {
    setDeleteItem: (
      state,
      {
        payload: {deleteItemId},
      }: PayloadAction<{deleteItemId: string}>,
    ) => {
      state.isDeleting = deleteItemId ? true : false;
      state.deleteItemId = deleteItemId;
    },
    setSharing: (
      state,
      {
        payload: {itemId, status},
      }: PayloadAction<{
        itemId: string;
        status: true | undefined;
      }>,
    ) => {
      state.sharing[itemId] = status;
    },
    setDownloadingProgress: (
      state,
      {
        payload: {itemId, progress},
      }: PayloadAction<{
        itemId: string;
        progress: number | undefined;
      }>,
    ) => {
      state.downloadingProgress[itemId] = progress;
    },
  },
});

export const {setDeleteItem, setDownloadingProgress, setSharing} =
  FileSystemSlice.actions;

export default FileSystemSlice.reducer;
